import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { getPublication, createPublication, updatePublication } from "../../api/publicationsApi";
import { translateAuthError } from "../../api/authApi";
import { PUBLICATION_ICONS } from "../../data/publicationIcons";

// Section C (admin-only): shared create/edit form for a publication
// (magazine). Presence of the :slug route param decides the mode — slug
// itself is immutable once created, so it's only editable at creation.
function PublicationFormPage() {
  const { slug } = useParams();
  const isEdit = Boolean(slug);
  const [slugInput, setSlugInput] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [description, setDescription] = useState("");
  const [iconKey, setIconKey] = useState(PUBLICATION_ICONS[0].key);
  const [tagsInput, setTagsInput] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(isEdit);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!isEdit) return;
    getPublication(slug)
      .then((pub) => {
        setTitle(pub.title);
        setSubtitle(pub.subtitle);
        setDescription(pub.description);
        setIconKey(pub.icon_key);
        setTagsInput(pub.tags.join(", "));
      })
      .catch((err) => setError(translateAuthError(err.message)))
      .finally(() => setLoading(false));
  }, [slug, isEdit]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");

    const tags = tagsInput
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

    try {
      if (isEdit) {
        await updatePublication(token, slug, { title, subtitle, description, icon_key: iconKey, tags });
      } else {
        await createPublication(token, {
          slug: slugInput,
          title,
          subtitle,
          description,
          icon_key: iconKey,
          tags,
        });
      }
      navigate("/admin/publications");
    } catch (err) {
      setError(translateAuthError(err.message));
    }
  }

  return (
    <div className="admin-page">
      <Link to="/admin/publications" className="back-link">
        ← بازگشت به فهرست نشریه‌ها
      </Link>

      {loading ? (
        <p>در حال بارگذاری...</p>
      ) : (
        <form className="auth-card admin-article-form" onSubmit={handleSubmit}>
          <span className="corner corner-tr" />
          <span className="corner corner-tl" />
          <span className="corner corner-br" />
          <span className="corner corner-bl" />

          <h2>{isEdit ? "ویرایش نشریه" : "نشریهٔ جدید"}</h2>

          {error && <p className="error">{error}</p>}

          {isEdit ? (
            <p>نامک: {slug}</p>
          ) : (
            <div className="auth-field">
              <label htmlFor="slug">نامک (Latin، یکتا)</label>
              <input
                id="slug"
                type="text"
                value={slugInput}
                onChange={(e) => setSlugInput(e.target.value)}
                required
              />
            </div>
          )}

          <div className="auth-field">
            <label htmlFor="title">عنوان</label>
            <input id="title" type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>

          <div className="auth-field">
            <label htmlFor="subtitle">زیرعنوان</label>
            <input
              id="subtitle"
              type="text"
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="description">توضیح</label>
            <textarea
              id="description"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="tags">برچسب‌ها (با ویرگول جدا کنید)</label>
            <input id="tags" type="text" value={tagsInput} onChange={(e) => setTagsInput(e.target.value)} />
          </div>

          <div className="auth-field">
            <label>آیکون</label>
            <div className="icon-picker">
              {PUBLICATION_ICONS.map((icon) => (
                <label
                  key={icon.key}
                  className={"icon-swatch" + (iconKey === icon.key ? " icon-swatch--selected" : "")}
                  title={icon.label}
                >
                  <input
                    type="radio"
                    name="icon_key"
                    value={icon.key}
                    checked={iconKey === icon.key}
                    onChange={() => setIconKey(icon.key)}
                  />
                  {icon.svg}
                </label>
              ))}
            </div>
          </div>

          <button type="submit" className="auth-submit">
            {isEdit ? "ذخیرهٔ تغییرات" : "ایجاد نشریه"}
          </button>
        </form>
      )}
    </div>
  );
}

export default PublicationFormPage;
